export function convertUnixTimestampToMiliseconds(unixTimestamp: number): number {
  return unixTimestamp * 1000;
}
